module.exports = __webpack_public_path__ + "static/img/nav_pic5.1e15b1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/nav/nav_pic5.jpg
// module id = eiZH
// module chunks = 37